<template>
  <div>
    <div class="items">
      <div class="item card-white">
        <!-- :class="{ 'margin-200-top': status.complete } -->

        <div class="card" v-if="!status.complete">
          <eyebrow-icon
            v-if="true"
            v-bind:eyebrowicon="{ icon: 'star-outline', color: 'black' }"
            v-bind:align="'center'"
          ></eyebrow-icon>
          <h4>Share your feedback on {{ this.acf.model }}</h4>
        </div>

        <form
          id="ContactForm"
          ref="contact_form"
          class="contact-form"
          action="javascript:"
          v-on:submit.prevent="submit"
        >
          <div v-if="!status.complete">
            <!-- stars rating -->
            <starRating></starRating>

            <div class="group">
              <label for="userLength"
                >How often are you replacing your mask cushion?</label
              >
              <select
                class="validation selectOptGroup"
                id="userLength"
                v-bind:class="{ '-invalid': validation.replacementFrequency }"
                v-model="fields.replacementFrequency"
                @change="validation.replacementFrequency = null"
              >
                <option selected disabled value="">
                  Select from the following options...
                </option>
                <option value="Every month">Every month</option>
                <option value="Every 2 – 3 months">Every 2 – 3 months</option>
                <option value="Every 6 months">Every 6 months</option>
                <option value="I have never replaced my mask cushion">
                  I have never replaced my mask cushion
                </option>
              </select>
              <div
                class="error-message"
                v-for="message in validation.replacementFrequency"
              >
                {{ message }}
              </div>
            </div>

            <h5>Please leave your review</h5>

            <div class="card-container">
              <div class="card-title">
                <img src="@/assets/images/info-solid.svg" class="info-svg" />
                <span class="s-title"
                  >When writing a review please refrain from:
                </span>
              </div>
              <div class="card-message">
                <div class="item-message">
                  1. Directly naming other companies or products good or bad.
                </div>
                <div class="item-message">
                  2. Using inappropriate or profane language.
                </div>
                <div class="item-message">
                  3. Disclosing personally identifiable information.
                </div>
              </div>
            </div>
            <br />

            <div class="group">
              <label for="recommendProduct"
                >Would you recommend this mask to other CPAP users?</label
              >

              <label class="check container-radio" for="yes_3"
                >Yes
                <input
                  type="radio"
                  id="yes_3"
                  name="recommendProduct"
                  v-model="fields.recommendProduct"
                  value="yes"
                  @change="validation.recommendProduct = null"
                />
                <span class="checkmark"></span>
              </label>

              <label class="check container-radio" for="no_3"
                >No
                <input
                  type="radio"
                  id="no_3"
                  name="recommendProduct"
                  v-model="fields.recommendProduct"
                  value="no"
                  @change="validation.recommendProduct = null"
                />
                <span class="checkmark"></span>
              </label>

              <div
                class="error-message only-text"
                v-for="message in validation.recommendProduct"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="reviewTitle">Review title</label>
              <input
                type="text"
                class="validation"
                id="reviewTitle"
                placeholder="Add a title (max 35 characters)"
                v-bind:class="{ '-invalid': validation.reviewTitle }"
                v-model="fields.reviewTitle"
                v-on:keyup="validation.reviewTitle = null"
                maxlength="35"
              />
              <div
                class="error-message"
                v-for="message in validation.reviewTitle"
              >
                {{ message }}
              </div>
            </div>

            <div class="group">
              <label for="reviewDescription">Review</label>
              <textarea
                class="validation"
                id="reviewDescription"
                placeholder="Please write your review here (min 50 characters)"
                v-bind:class="{ '-invalid': validation.reviewDescription }"
                v-model="fields.reviewDescription"
                v-on:keyup="validation.reviewDescription = null"
              ></textarea>
              <div
                class="error-message"
                v-for="message in validation.reviewDescription"
              >
                {{ message }}
              </div>
            </div>

            <!-- firstname -->
            <firstname></firstname>

            <!-- lastname -->
            <lastname></lastname>

            <!-- email and phone -->
            <email></email>

            <!-- select: country -->
            <country></country>

            <!-- select: satate -->
            <component :is="states[fields.country]"></component>

            <!-- checkbox: feedbackConcent -->
            <feedbackConsent></feedbackConsent>

            <!-- checkbox: marketing_oncent -->
            <marketingConsent></marketingConsent>

            <!-- submit, validation and confirmation -->
            <submit-confirmation></submit-confirmation>

            <input type="hidden" name="maskModel" v-model="fields.maskModel" />
            <input type="hidden" name="maskBrand" v-model="fields.maskBrand" />
          </div>
        </form>
        <thankyou-message v-if="status.complete"></thankyou-message>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "./mixin";

let fillable = {
  starRating: "",
  replacementFrequency: "",
  recommendProduct: "",
  reviewTitle: "",
  reviewDescription: "",
  firstname: "",
  lastname: "",
  email: "",
  country: "",
  state: "",
  feedbackConsent: "",
  marketing_consent: true,
  referrer: window.location.pathname,
  b2c: "yes",
  b2b: "no",
  yes_Rating: true,
  no_Rating: false,
  maskBrand: "",
  maskModel: "",
  timeOnMachineDatestamp: "",
  marketingConsentDate: new Date().toISOString(),
};

export default {
  data() {
    return {
      form: {
        name: "", // form name
        origin: "", // form origin ( page )
      },
      status: {
        idle: null,
        step: [],
        last_step: [],
        errors: false,
        complete: false,
      },
      response: {
        type: "", // validation or confirmation
        message: "", // response
      },
      holdingValue: {},
      sendTimeOnMachineDatestamp: false,
      fields: { ...fillable },
      replacementFrequencyRequired: true,
      validation: {},
      states: {
        "United States": "stateUS",
        Canada: "stateCA",
      },
    };
  },
  mixins: [mixin],
};
</script>
